/* RESPONSIBLE TEAM: team-workflows */
import CustomBotSerializer from 'embercom/serializers/operator/custom-bot';

export default CustomBotSerializer.extend();
